/// <amd-module name="VSS/Features/Engagement/Feedback" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { ICommandStatus, ICommandStatusService } from "VSS/Platform/Contribution";
import { IVssPageService } from "VSS/Platform/Page";
import { Uri } from "VSS/Platform/Util/Url";

const reportProblemLink = "https://go.microsoft.com/fwlink/?linkid=2131420";
const hostedReportProblemLink = "https://go.microsoft.com/fwlink/?linkid=2167006";
const provideSuggestionLink = "https://go.microsoft.com/fwlink/?linkid=2131230";
const supportLink = "https://azure.microsoft.com/en-us/support/devops";
const supportLinkMS =
    "https://dev.azure.com/mseng/AzureDevOps/_wiki/wikis/AzureDevOps.wiki?wikiVersion=GBwikiMaster&pagePath=%2FAzure%20DevOps%20Support";

export interface IFeedbackService extends IVssService {
    contactSupport(): void;
    contactSupportMS(): void;
    provideSuggestion(): void;
    reportProblem(): void;
}

class FeedbackService extends VssService implements IFeedbackService, ICommandStatusService {
    public checkStatus(command: string): ICommandStatus {
        return { disabled: false };
    }

    public provideSuggestion(): void {
        window.open(provideSuggestionLink, "VSTS_provideSuggestion");
    }

    public reportProblem(): void {
        const pageService = this.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = pageService.getData();

        const isHosted = !!pageData?.isHosted;
        window.open(isHosted ? hostedReportProblemLink : reportProblemLink, "VSTS_provideSuggestion");
    }

    public contactSupport(): void {
        const target = new Uri(supportLink);

        const pageData = this.pageContext.getService<IVssPageService>("IVssPageService").getData()!;
        if (pageData.isHosted) {
            target.addQueryParam("ol", "0");
            target.addQueryParam("oi", pageData.hostId);
            target.addQueryParam("on", pageData.hostName);
        }

        window.open(target.absoluteUri, "_blank");
    }

    public contactSupportMS(): void {
        window.open(supportLinkMS, "_blank");
    }
}

Services.add("feedback-service", { serviceFactory: FeedbackService });
